import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { TableName } from "../tables/tableNames";

export function useRouterHook() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const addParamToUrl = (key: string, value: string | null | undefined) => {
    if (!value) {
      const params = new URLSearchParams(Array.from(searchParams.entries()));
      params.delete(key);
      router.push(`${pathname}?${params.toString()}`);
      return;
    }
    const params = new URLSearchParams(Array.from(searchParams.entries()));
    params.set(key, value);
    router.push(`${pathname}?${params.toString()}`);
  };

  const getParamFromUrl = (key: string, prefix: TableName | null) => {
    const params = new URLSearchParams(Array.from(searchParams.entries()));
    let value = params.get(key);
    if (!value) return value;
    if (prefix) return `${prefix}:${value}`;
    return value;
  };

  return { addParamToUrl, getParamFromUrl };
}
